import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@mui/material";
import React from "react";

export const MobileViewCellDataGrid = ({ tableData }) => {
  return (
    <TableContainer>
      <Table aria-label="simple table">
        <TableBody>
          {tableData.map((item, index) => (
            <TableRow key={index}>
              <TableCell component="th" scope="row">
                {item.label}
              </TableCell>
              <TableCell>{item.data}</TableCell>
              {item.action && <TableCell>{item.action}</TableCell>}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};
